import { Injectable } from "@angular/core";

@Injectable()
export class RecruitmentResponses {

    constructor() { }

}

export interface ResponseData<T> {
    data: T;
    message: string;
}

export interface ResponsePaging<T> {
    page: number;
    limit: number;
    total: number;
    totalPage: number;
    data: T[];
}


// WEBPACK FOOTER //
// ./src/shared/recruitment/recruitment-responses.ts